import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Navigation from './components/Navigation';
import TradeLikeMe from './pages/TradeLikeMe';
import Background from './pages/Background';
import Dashboard from './pages/Dashboard';
import Contact from './pages/Contact';
import { useAnalytics } from './hooks/useAnalytics';

// Component to handle analytics initialization
function AppContent() {
  // Initialize analytics tracking for page views, scroll depth, errors, etc.
  useAnalytics();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <Routes>
        <Route path="/" element={<Background />} />
        <Route path="/background" element={<Navigate to="/" replace />} />
        <Route path="/trade-like-me" element={<TradeLikeMe />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
      <Analytics />
    </Router>
  );
}

export default App;